import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { AlertCircle } from "lucide-react";
import { Slab } from "@/types/slab";
import { formatCurrency } from "@/lib/utils";

interface SlabListProps {
  slabs: Slab[];
  onSlabClick: (slab: Slab) => void;
}

export function SlabList({ slabs, onSlabClick }: SlabListProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Code</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Location</TableHead>
            <TableHead>Price</TableHead>
            <TableHead>Quantity</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {slabs.map((slab) => (
            <TableRow
              key={slab.id}
              className="cursor-pointer hover:bg-muted/50"
              onClick={() => onSlabClick(slab)}
            >
              <TableCell className="font-medium">{slab.code}</TableCell>
              <TableCell>{slab.name}</TableCell>
              <TableCell>
                <Badge variant="secondary">{slab.type}</Badge>
              </TableCell>
              <TableCell>{slab.location}</TableCell>
              <TableCell>{formatCurrency(slab.price)}</TableCell>
              <TableCell>{slab.quantity}</TableCell>
              <TableCell>
                {slab.quantity < 2 && (
                  <Badge variant="destructive" className="gap-1">
                    <AlertCircle className="h-4 w-4" />
                    Low Stock
                  </Badge>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}